import React from "react";
import { MessageCircle } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const SupportBanner: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-blue-300 to-[#092049] py-6 px-8 rounded-xl flex justify-between items-center shadow-lg">
      <h2 className="text-white text-2xl font-bold">
        Aklınızda soru işaretleri mi var?
      </h2>
      <a
        href="https://wa.me/905423983273"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#D9D9D9] text-black font-semibold py-2 px-4 rounded-lg flex items-center shadow-md hover:bg-gray-200 transition"
      >
        <FaWhatsapp className="w-5 h-5 mr-2" /> Whatsapp Hattı
      </a>
    </div>
  );
};

export default SupportBanner;
